module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_avatar-815b80bb71f366f5f4487e8c9534b28b.svg";